import { render } from "./PageVideoGuide.vue?vue&type=template&id=ce899ed6&scoped=true&ts=true"
import script from "./PageVideoGuide.vue?vue&type=script&lang=ts"
export * from "./PageVideoGuide.vue?vue&type=script&lang=ts"

import "./PageVideoGuide.vue?vue&type=style&index=0&id=ce899ed6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce899ed6"]])

export default __exports__